/**
 * Auth Storage Utility
 * 
 * When "Remember me" is checked, tokens are stored in localStorage (persistent).
 * Otherwise, tokens are stored in sessionStorage (cleared on tab close).
 * 
 * getItem() checks localStorage first, then sessionStorage — so reads
 * work regardless of which storage was used to write.
 */

const AUTH_KEYS = ['email', 'refreshToken', 'accessToken', 'sessionToken'];

const authStorage = {
    /**
     * Store auth data. Uses localStorage if rememberMe is true, sessionStorage otherwise.
     */
    setItem(key, value, rememberMe = false) {
        if (rememberMe) {
            localStorage.setItem(key, value);
        } else {
            sessionStorage.setItem(key, value);
        }
    },

    /**
     * Read auth data. Checks localStorage first, then sessionStorage.
     */
    getItem(key) {
        return localStorage.getItem(key) || sessionStorage.getItem(key);
    },

    /**
     * Clear all auth data from both storages.
     */
    clear() {
        AUTH_KEYS.forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    },

    /**
     * Check if "remember me" was used (tokens exist in localStorage).
     */
    isRemembered() {
        return !!localStorage.getItem('accessToken');
    }
};

export default authStorage;
